document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-nd-guide-wrap]').forEach(function (wrap) {
    var placeholderOpt = wrap.querySelector('select[data-nd-guide-select] option[value=""]');
    if (placeholderOpt) { placeholderOpt.textContent = 'Bitte auswählen'; }
  });

  // NeckDream: Schwarz ist vorausgewaehlt (keine Pflicht-Farbauswahl mehr).
  // Die Auswahl wird per change-Event gesetzt, damit die Theme-Logik
  // (Varianten-ID, Preis, zweite Kaufbox) synchron bleibt.
  document.querySelectorAll('[data-nd-variant-select]').forEach(function (select) {
    var ph = select.querySelector('option[data-nd-color-placeholder]');
    if (ph) ph.remove();
    select.required = false;
    var def = Array.prototype.find.call(select.options, function (o) { return /^(schwarz|black)$/i.test((o.textContent || '').trim()) && !o.disabled; });
    if (def && select.value !== def.value) {
      select.value = def.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
});

// Homepage quick-add stays on the homepage and has no guide/consent
// selection of its own, so after a successful add there, open the cart
// drawer (refreshed with fresh sections) so the customer can add a guide
// and see the consent flow if needed.
(function () {
  var ndHomepageAddPending = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rl-highlight-add]');
    if (!btn || btn.disabled) return;
    ndHomepageAddPending = true;
    setTimeout(function () { ndHomepageAddPending = false; }, 4000);
  }, true);

  var ndOrigFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = url.indexOf('/cart/add') !== -1;
    var wasHomepageAdd = isCartAdd && ndHomepageAddPending;
    if (isCartAdd) { ndHomepageAddPending = false; }
    var p = ndOrigFetch.apply(this, arguments);
    if (wasHomepageAdd) {
      p.then(function (res) {
        if (res && res.ok) { ndOpenCartDrawerFresh(); }
      });
    }
    return p;
  };

  function ndOpenCartDrawerFresh() {
    // With cart_type set to "page" there is no <cart-drawer> element on
    // the page at all -- the old early "return" here used to bail out
    // completely in that case, which meant the header's cart-count
    // bubble was never refreshed either (it was only ever updated as a
    // side effect of successfully opening the drawer). Now: always
    // refresh the bubble: only touch the drawer when one actually exists.
    var cartDrawer = document.querySelector('cart-drawer');
    var hasDrawer = !!(cartDrawer && typeof cartDrawer.open === 'function');
    var sectionsToRequest = hasDrawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (liveCart) {
        if (!liveCart.items.length) return;
        var probe = liveCart.items[0];
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: probe.key,
            quantity: probe.quantity,
            sections: sectionsToRequest,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r && r.json(); })
      .then(function (state) {
        if (state && state.sections) {
          if (hasDrawer) {
            var drawerHtml = state.sections['cart-drawer'];
            if (drawerHtml) {
              var parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
              var freshDrawer = parsed.querySelector('cart-drawer');
              if (freshDrawer) cartDrawer.innerHTML = freshDrawer.innerHTML;
            }
          }
          var bubbleHtml = state.sections['cart-icon-bubble'];
          if (bubbleHtml) {
            var bubbleTarget = document.getElementById('cart-icon-bubble');
            if (bubbleTarget) {
              var parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
              var freshBubble = parsedBubble.querySelector('.shopify-section') || parsedBubble.body.firstElementChild;
              if (freshBubble) bubbleTarget.innerHTML = freshBubble.innerHTML;
            }
          }
        }
        if (hasDrawer) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.open();
        }
      })
      .catch(function () {
        if (hasDrawer) cartDrawer.open();
      });
  }

  // Reiseguide product pages (sections/reiseguides.liquid) run their own
  // separate add-to-cart flow and only ask Shopify's Section Rendering API
  // for sections whose DOM target is `#shopify-section-<handle>` -- but the
  // header's cart icon here is just a plain `id="cart-icon-bubble"` link,
  // not wrapped that way, so that request is silently skipped and the
  // header count stays stale until a full reload. That page does already
  // dispatch a 'cart:updated' event after every successful add, so listen
  // for it here and reuse the same bubble-refresh logic instead of having
  // to touch that (very large) template file.
  document.addEventListener('cart:updated', function () { ndOpenCartDrawerFresh(); });

  // The Reiseguide COLLECTION grid (sections/guide-collection.liquid, used
  // on /collections/reiseguides) has the exact same issue: its own
  // add-to-cart flow also only targets `#shopify-section-cart-icon-bubble`,
  // which doesn't exist either, so the header count stays stale there too
  // until a full reload. It already dispatches its own
  // 'guidehub:cart-changed' event after every successful add -- but on
  // `window`, not `document` -- so the listener has to be on `window` too,
  // otherwise it silently never fires.
  window.addEventListener('guidehub:cart-changed', function () { ndOpenCartDrawerFresh(); });

  // Exposed globally so other add-to-cart flows on the site (e.g. the
  // NeckDream product page's own custom add-to-cart handler) can reuse the
  // same "refresh + open drawer" behaviour instead of hard-redirecting to
  // the big cart page.
  window.ndOpenCartDrawerFresh = ndOpenCartDrawerFresh;
})();

// The bottom "final CTA" buy box repeats the color picker purely for
// display. Letting it be a real, separate selection would let a customer
// add to cart from there without ever seeing the guide upsell/consent flow
// near the top of the page. So: remove that duplicate color field entirely
// (the theme's own "single variant" layout reflows the box without it), and
// make its button scroll back up to the real, interactive selectors instead
// of adding to cart directly from the bottom.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.nd-final-variant').forEach(function (variantLabel) {
    var actionBox = variantLabel.closest('.nd-final-action');
    variantLabel.remove();
    if (actionBox) actionBox.classList.add('is-single');
  });
});

document.addEventListener('click', function (e) {
  var el = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
  var btn = el && el.closest && el.closest('.nd-final-action [data-nd-buy-proxy]');
  if (!btn || btn.disabled) return;
  var root = btn.closest('[id^="ND-"]');
  if (!root) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var scrollTarget = root.querySelector('[data-nd-hero]') || root.querySelector('[data-nd-form]') || root;
  scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  var topSelect = root.querySelector('[data-nd-variant-select]');
  if (topSelect && typeof topSelect.focus === 'function') {
    setTimeout(function () { topSelect.focus({ preventScroll: true }); }, 420);
  }
}, true);

// Reiselieblinge: Dream-Linie im Menue als Name + feine Unterzeile darstellen
// ("NeckDream – Nackenstütze" -> NeckDream / NACKENSTÜTZE) und
// "Alle Produkte ansehen" als hinterlegte Abschlusszeile hervorheben.
// Der Produktname uebernimmt die Schriftgroesse der Hauptmenue-Punkte;
// bei der aktiven Seite wird nur der Name unterstrichen.
(function () {
  var re = /^\s*(NeckDream|EyeDream|EarDream|Dream-Sets)\s+[–-]\s+(.+?)\s*$/;
  function topFontSize() {
    var labels = ['Reiseguides', 'Magazin', 'Über uns', 'Reisekomfort', 'Travel guides', 'Magazine', 'About us'];
    var hdr = document.querySelector('header') || document;
    var cands = hdr.querySelectorAll('a, summary, span');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (el.closest('.menu-drawer, menu-drawer, [class*="submenu"], [class*="drawer"]')) continue;
      if (labels.indexOf((el.textContent || '').trim()) === -1) continue;
      if (el.children.length && Array.prototype.some.call(el.children, function (c) { return labels.indexOf((c.textContent || '').trim()) !== -1; })) continue;
      if (!el.offsetParent) continue;
      return getComputedStyle(el).fontSize;
    }
    return '';
  }
  function samePath(a) {
    try { var p = new URL(a.href, location.href).pathname.replace(/\/$/, ''); return p && p === location.pathname.replace(/\/$/, ''); } catch (e) { return false; }
  }
  function rlMenu() {
    var fs = topFontSize();
    if (fs) document.documentElement.style.setProperty('--rlm-fs', fs);
    document.querySelectorAll('header a, .menu-drawer a, menu-drawer a, details a, nav a').forEach(function (a) {
      if (a.dataset.rlm) return;
      var t = (a.textContent || '').trim();
      var m = t.match(re);
      if (m) {
        var target = a;
        var inner = Array.prototype.find.call(a.querySelectorAll('span'), function (s) { return (s.textContent || '').trim() === t; });
        if (inner) target = inner;
        a.dataset.rlm = '1';
        target.classList.add('rlm-item');
        target.innerHTML = '<span class="rlm-n"></span><span class="rlm-s"></span>';
        target.querySelector('.rlm-n').textContent = m[1];
        target.querySelector('.rlm-s').textContent = m[2];
        if (samePath(a)) a.classList.add('rlm-active');
      } else if (/^(Alle Produkte ansehen|View all products)$/i.test(t)) {
        a.dataset.rlm = '1';
        a.classList.add('rlm-all');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rlMenu); else rlMenu();
  window.addEventListener('load', rlMenu);
  window.addEventListener('resize', function () { var fs = topFontSize(); if (fs) document.documentElement.style.setProperty('--rlm-fs', fs); });
})();

// Reiselieblinge: NeckDream "Auf einen Blick" (wie bei EyeDream/EarDream),
// Angaben aus den bestehenden NeckDream-Texten abgeleitet.
(function () {
  function rlSpecs() {
    document.querySelectorAll('.nd-root').forEach(function (root) {
      if (root.querySelector('[data-dp-form]') || root.querySelector('.rl-specs')) return;
      var lead = root.querySelector('.nd-buy .nd-lead');
      if (!lead) return;
      var en = /^en/i.test(document.documentElement.lang || '');
      var items = en ? [['Shape', 'Body-hugging neck support'], ['Use', 'Plane, train, car & home'], ['Handling', 'No inflating, packs compactly'], ['Care', 'Remove support insert, follow care label']]
        : [['Form', 'Körpernahe Nackenstütze'], ['Einsatz', 'Flugzeug, Zug, Auto & Zuhause'], ['Handhabung', 'Ohne Aufblasen, kompakt verstaubar'], ['Pflege', 'Stützelement entfernen, Pflegehinweise beachten']];
      var box = document.createElement('div');
      box.className = 'rl-specs';
      var t = document.createElement('p'); t.className = 'rl-specs-t'; t.textContent = en ? 'At a glance' : 'Auf einen Blick'; box.appendChild(t);
      var dl = document.createElement('dl'); box.appendChild(dl);
      items.forEach(function (it) {
        var d = document.createElement('div'); d.className = 'rl-spec';
        var dt = document.createElement('dt'); dt.textContent = it[0];
        var dd = document.createElement('dd'); dd.textContent = it[1];
        d.appendChild(dt); d.appendChild(dd); dl.appendChild(d);
      });
      lead.insertAdjacentElement('afterend', box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rlSpecs); else rlSpecs();
})();

// Reiselieblinge: NeckDream-Farbauswahl als Farbkreise (wie EyeDream/EarDream)
// und Menge neben dem Warenkorb-Button. Das originale Auswahlfeld bleibt
// unsichtbar im Formular, damit Pflichtauswahl und Theme-Logik erhalten bleiben.
(function () {
  var C = { 'Grau': '#8E8E93', 'Schwarz': '#1d1d1f', 'Rot': '#D24F4A', 'Korallrot': '#D24F4A', 'Grey': '#8E8E93', 'Gray': '#8E8E93', 'Black': '#1d1d1f', 'Red': '#D24F4A', 'Coral red': '#D24F4A', 'Coral Red': '#D24F4A', 'Coral': '#D24F4A' };
  function rlNdBuy() {
    var en = /^en/i.test(document.documentElement.lang || '');
    document.querySelectorAll('.nd-root').forEach(function (root) {
      if (root.querySelector('[data-dp-form]') || root.dataset.rlBuy) return;
      var buy = root.querySelector('.nd-buy');
      if (!buy) return;
      root.dataset.rlBuy = '1';
      var sel = buy.querySelector('[data-nd-variant-select]');
      var lab = buy.querySelector('.nd-variant label');
      if (sel && lab) {
        sel.classList.add('rl-vh');
        lab.textContent = (lab.textContent || '').replace(/:\s*$/, '').trim() + ':';
        var name = document.createElement('span'); name.className = 'rl-swname'; lab.appendChild(name);
        var wrap = document.createElement('div'); wrap.className = 'rl-sw'; wrap.setAttribute('role', 'group');
        var upd = function () {
          var o = sel.options[sel.selectedIndex];
          name.textContent = (o && o.value && !o.disabled) ? o.textContent.trim() : (en ? 'Please select' : 'Bitte auswählen');
          wrap.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.v === sel.value ? 'true' : 'false'); });
        };
        var rlOpts = Array.prototype.slice.call(sel.options);
        rlOpts.sort(function (a, b) { var ka = /^(schwarz|black)$/i.test((a.textContent || '').trim()) ? 0 : 1, kb = /^(schwarz|black)$/i.test((b.textContent || '').trim()) ? 0 : 1; return ka - kb; });
        rlOpts.forEach(function (o) {
          var t = (o.textContent || '').trim();
          if (!o.value || o.disabled || /bitte|please/i.test(t)) return;
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.v = o.value; b.title = t; b.setAttribute('aria-label', t);
          b.style.setProperty('--c', C[t] || '#ccc');
          b.addEventListener('click', function () { sel.value = o.value; sel.dispatchEvent(new Event('change', { bubbles: true })); sel.dispatchEvent(new Event('input', { bubbles: true })); upd(); });
          wrap.appendChild(b);
        });
        sel.addEventListener('change', upd);
        sel.parentNode.insertBefore(wrap, sel);
        var hint = document.createElement('p'); hint.className = 'rl-opt-hint';
        hint.style.cssText = 'margin:10px 0 0;font-size:12.5px;line-height:1.5;letter-spacing:.01em;opacity:.66';
        hint.textContent = en ? 'Illustrative images – design and colours may vary.' : 'Symbolbilder – Ausführung und Farben können abweichen.';
        sel.parentNode.appendChild(hint);
        upd();
      }
      var q = buy.querySelector('.nd-quantity');
      var cta = buy.querySelector('form .nd-cta');
      if (q && cta) {
        var row = document.createElement('div'); row.className = 'rl-buyrow';
        cta.parentNode.insertBefore(row, cta);
        row.appendChild(q); row.appendChild(cta);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rlNdBuy); else rlNdBuy();
})();

// Reiselieblinge: NeckDream-Abschluss-Button wie bei EyeDream/EarDream
// ("JETZT AUSWÄHLEN", springt nach oben zur Auswahl).
(function () {
  function rlFinalBtn() {
    var en = /^en/i.test(document.documentElement.lang || '');
    var label = en ? 'CHOOSE NOW' : 'JETZT AUSWÄHLEN';
    document.querySelectorAll('.nd-root .nd-final-action [data-nd-buy-proxy]').forEach(function (b) {
      var root = b.closest('.nd-root');
      if (!root || root.querySelector('[data-dp-form]')) return;
      var apply = function () { if (b.textContent.trim() !== label) b.textContent = label; if (b.disabled) b.disabled = false; };
      apply();
      if (!b.dataset.rlObs && window.MutationObserver) {
        b.dataset.rlObs = '1';
        new MutationObserver(apply).observe(b, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rlFinalBtn); else rlFinalBtn();
  window.addEventListener('load', rlFinalBtn);
})();

// Reiselieblinge: NeckDream-Abschluss (Haekchen wie EyeDream/EarDream) und
// Bewertungen vor den Abschluss setzen (Ablauf: Vertrauen -> Beweis -> Kauf).
(function () {
  function rlNdLayout() {
    var en = /^en/i.test(document.documentElement.lang || '');
    document.querySelectorAll('.nd-root').forEach(function (root) {
      if (root.querySelector('[data-dp-form]')) return;
      root.querySelectorAll('.nd-final-trust span:not(.rl-ck)').forEach(function (s) {
        s.textContent = (s.textContent || '').replace(/^\s*✓\s*/, '').trim();
        s.classList.add('rl-ck');
      });
      if (root.dataset.rlRev) return;
      var fin = root.querySelector('.nd-final-wrap');
      if (!fin) return;
      var sec = Array.prototype.find.call(document.querySelectorAll('.shopify-section'), function (s) {
        return !s.contains(root) && s.querySelector('[class*="loox" i],[id*="loox" i],iframe[src*="loox"]');
      });
      if (!sec) return;
      root.dataset.rlRev = '1';
      var wrap = document.createElement('div');
      wrap.className = 'rl-reviews';
      var hd = document.createElement('div'); hd.className = 'rl-reviews-hd';
      var p = document.createElement('p'); p.textContent = en ? 'EXPERIENCES' : 'ERFAHRUNGEN';
      var h = document.createElement('h2'); h.textContent = en ? 'What travellers say about NeckDream.' : 'Das sagen Reisende über NeckDream.';
      hd.appendChild(p); hd.appendChild(h); wrap.appendChild(hd);
      fin.parentNode.insertBefore(wrap, fin);
      wrap.appendChild(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rlNdLayout); else rlNdLayout();
  window.addEventListener('load', rlNdLayout);
})();

// Reiselieblinge: NeckDream-Abschluss mit drei Punkten wie EyeDream/EarDream
(function () {
  function rlTrust3() {
    var en = /^en/i.test(document.documentElement.lang || '');
    document.querySelectorAll('.nd-root .nd-final-trust').forEach(function (t) {
      var root = t.closest('.nd-root');
      if (!root || root.querySelector('[data-dp-form]') || t.dataset.rl3) return;
      t.dataset.rl3 = '1';
      if (t.querySelectorAll('span').length < 3) {
        var s = document.createElement('span');
        s.className = 'rl-ck';
        s.textContent = en ? 'Secure payment' : 'Sicher bezahlen';
        t.appendChild(s);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rlTrust3); else rlTrust3();
  window.addEventListener('load', rlTrust3);
})();

// Reiselieblinge: NeckDream startet immer ganz oben (wie EyeDream/EarDream),
// ausser es wird gezielt zu einem Anker gesprungen oder der Nutzer scrollt selbst.
(function () {
  if (location.hash) return;
  var isNd = function () { var r = document.querySelector('.nd-root'); return r && !r.querySelector('[data-dp-form]'); };
  var user = false;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, function () { user = true; }, { passive: true, once: true }); });
  if ('scrollRestoration' in history) { try { if (document.querySelector('.nd-root')) history.scrollRestoration = 'manual'; } catch (e) {} }
  var top = function () { if (!user && isNd() && window.scrollY > 0) window.scrollTo(0, 0); };
  document.addEventListener('DOMContentLoaded', top);
  window.addEventListener('load', function () { top(); setTimeout(top, 250); setTimeout(top, 800); });
})();

// Reiselieblinge: Bewertungen ohne zusaetzliche Hinterlegung/Karte und
// NeckDream-Abschluss mit exakt denselben Massen wie EyeDream/EarDream.
(function () {
  var P = '.nd-root:not(:has([data-dp-form]))';
  var css = '.rl-reviews{border-image:none!important;padding-block:clamp(36px,5vw,64px)!important}.rl-reviews>.shopify-section{background:none!important;border:0!important;box-shadow:none!important;padding:0!important;border-radius:0!important;max-width:none!important}'
    + P + ' .nd-final-wrap{padding:clamp(40px,5vw,64px) 0!important}'
    + P + ' .nd-final-wrap .nd-shell{padding-top:0!important;padding-bottom:0!important}'
    + P + ' .nd-final .nd-eyebrow{font-size:12px!important;letter-spacing:.16em!important;margin:0 0 14px!important}'
    + P + ' .nd-final-title{margin:0 auto 6px!important;line-height:1.08!important}'
    + P + ' .nd-final-action{margin:0!important}'
    + P + ' .nd-final-price{margin:26px 0 34px!important}'
    + P + ' .nd-final-trust{margin:26px 0 0!important;font-size:12px!important;letter-spacing:.08em!important}'
    + P + ' .nd-final-trust span{color:#EDE8E1!important;opacity:.85!important;font-weight:400!important}'
    + P + ' .nd-final-trust span.rl-ck:before{background:rgba(255,255,255,.16)!important}';
  var st = document.createElement('style'); st.textContent = css; (document.head || document.documentElement).appendChild(st);
})();

// Reiselieblinge: NeckDream-Abschluss final angleichen (alles weiss, gleiche
// Abstaende/Hoehe wie EyeDream/EarDream, MwSt.-Hinweis hell).
(function () {
  var P = '.nd-root:not(:has([data-dp-form]))';
  var css = P + ' .nd-final,' + P + ' .nd-final *{color:#fff!important}'
    + P + ' .nd-final .nd-eyebrow{color:#FBEBDD!important}'
    + P + ' .nd-final-action .nd-cta{color:#9C7556!important}'
    + P + ' .nd-final{min-height:0!important;gap:0!important}'
    + P + ' .nd-final > div:first-child{margin:0!important;padding:0!important;min-height:0!important}'
    + P + ' .nd-final-action > :not(.nd-final-price):not(.nd-cta):not(.nd-final-trust):not([class*="tax"]){display:none!important}'
    + P + ' .nd-final-action > [class*="tax"]{order:1;margin:2px 0 34px!important}'
    + P + ' .nd-final-action:has(> [class*="tax"]) .nd-final-price{margin-bottom:0!important}'
    + P + ' .nd-final-wrap > *{margin-top:0!important;margin-bottom:0!important}';
  var st = document.createElement('style'); st.textContent = css; (document.head || document.documentElement).appendChild(st);
  function light() {
    document.querySelectorAll('.nd-root .nd-final .rl-tax-note, .nd-root .nd-final .rl-tax-note *, .nd-root .nd-final .tax-note, .nd-root .nd-final .tax-note *').forEach(function (n) {
      var root = n.closest('.nd-root');
      if (!root || root.querySelector('[data-dp-form]')) return;
      n.style.setProperty('color', '#fff', 'important');
      n.style.setProperty('opacity', '.85', 'important');
      n.style.setProperty('font-size', '12.5px', 'important');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', light); else light();
  window.addEventListener('load', function () { light(); [600, 1600, 3600].forEach(function (t) { setTimeout(light, t); }); });
})();

// Reiselieblinge: NeckDream-Abschluss ohne Linien + dunkler Espresso-Footer
(function () {
  var P = '.nd-root:not(:has([data-dp-form]))';
  var F = 'footer:is(#rlf,[id^="RLFooter-"])';
  var css = ''
    + P + ' .nd-final-wrap,' + P + ' .nd-final-wrap *{border-top:0!important;border-bottom:0!important}'
    + P + ' .nd-final-wrap::before,' + P + ' .nd-final-wrap::after,' + P + ' .nd-final-action::before,' + P + ' .nd-final-action::after,' + P + ' .nd-final-trust::before,' + P + ' .nd-final-trust::after,' + P + ' .nd-final > div:first-child::before,' + P + ' .nd-final > div:first-child::after,' + P + ' .nd-final-price::after{content:none!important;display:none!important}'
    + P + ' .nd-final hr{display:none!important}'
    + F + '{margin-top:0!important;border-top:0!important;background:linear-gradient(180deg,#30261F 0%,#271F19 100%)!important;color:#EDE3D8!important}'
    + F + ' .footer-block__heading{color:#C9A688!important}'
    + F + ' .footer-block__newsletter .footer-block__heading{color:#FBF4EC!important}'
    + F + ' .footer-block__details-content,' + F + ' .footer-block__details-content .list-menu__item--link{color:rgba(237,227,216,.72)!important}'
    + F + ' .footer-block__details-content a{color:rgba(237,227,216,.86)!important;text-decoration-color:rgba(201,166,136,.5)!important}'
    + F + ' .footer-block__details-content a:hover,' + F + ' .footer-block__details-content .list-menu__item--link:hover,' + F + ' .footer-block__details-content .list-menu__item--active{color:#D9BFA6!important}'
    + F + ' .newsletter-form__field-wrapper .field__input{background:rgba(255,255,255,.06)!important;border-color:rgba(201,166,136,.38)!important;color:#FBF4EC!important}'
    + F + ' .newsletter-form__field-wrapper .field__label{color:rgba(237,227,216,.55)!important}'
    + F + ' .newsletter-form__button{background:#BE9B7D!important;color:#fff!important}'
    + F + ' .list-social__link{background:rgba(255,255,255,.06)!important;border-color:rgba(201,166,136,.3)!important;color:#D9BFA6!important}'
    + F + ' .localization-form h2{color:rgba(237,227,216,.5)!important}'
    + F + ' .localization-form__select{background:rgba(255,255,255,.06)!important;border-color:rgba(201,166,136,.3)!important;color:rgba(237,227,216,.82)!important}'
    + F + ' .localization-form__select .icon-caret{color:rgba(237,227,216,.7)!important}'
    + F + ' .footer__content-bottom-wrapper{border-top:1px solid rgba(201,166,136,.18)!important}'
    + F + ' .footer__copyright{color:rgba(237,227,216,.45)!important}'
    + F + ' .list-payment__item{opacity:.92}';
  var st = document.createElement('style'); st.textContent = css; (document.head || document.documentElement).appendChild(st);
})();
